<template>
  <v-dialog max-width="600px" v-model="dialogState">
    <v-card rounded="lg">
      <v-card-title class="text-center primary lighten-2">
        <p class="mx-auto text-h4 font-weight-semibold white--text">
          Welcome to Revitalize!
        </p>
      </v-card-title>
      <v-card-text class="pa-10">
        <v-row align="center" justify="center">
          <v-col
            xs="10"
            sm="10"
            md="7"
            lg="7"
            xl="7"
            class="justify-center d-flex align-center"
          >
            <v-btn
              depressed
              large
              class="rounded-lg"
              color="primary"
              @click="signInWithGoogle"
            >
              Continue in With Google
              <v-icon right>fab fa-google</v-icon>
            </v-btn>
          </v-col>
          <v-col
            xs="10"
            sm="10"
            md="7"
            lg="7"
            xl="7"
            class="justify-center d-flex align-center"
          >
            <v-btn
              depressed
              large
              class="rounded-lg"
              color="primary"
              @click="signInWithFacebook"
            >
              Continue in With Facebook
              <v-icon right>fab fa-facebook</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ANALYTICS } from '@/configs/firebase'
import { logEvent } from 'firebase/analytics'
export default {
  name: 'AuthModal',
  data: () => ({
    dialogState: false
  }),
  methods: {
    open() {
      this.dialogState = true
    },
    close() {
      this.dialogState = false
    },
    async signInWithGoogle() {
      await this.$store.dispatch('users/LOGIN_THROUGH_GOOGLE')
      window.location.reload(false)
      logEvent(ANALYTICS, 'login_with_google')
      this.dialogState = false
    },
    async signInWithFacebook() {
      await this.$store.dispatch('users/LOGIN_THROUGH_FACEBOOK')
      window.location.reload(false)
      logEvent(ANALYTICS, 'login_with_facebook')
      this.dialogState = false
    }
  }
}
</script>

<style></style>
